module.exports = __webpack_public_path__ + "cam.png?f7c565d3cca4c1edf967df107619eea7";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/cam.png
// module id = 85
// module chunks = 0